import { render, staticRenderFns } from "./menu_list.vue?vue&type=template&id=b99f4c0e&"
import script from "./menu_list.vue?vue&type=script&lang=js&"
export * from "./menu_list.vue?vue&type=script&lang=js&"
import style0 from "./menu_list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports